import { Compass, Sparkles, ArrowUpRight, Target, BookOpen, Globe, Handshake } from 'lucide-react';

export const getHowItWorksSteps = (language) => {
  if (language === 'nl') {
    return [
      {
        icon: Compass,
        step: 1,
        title: 'Bladeren',
        description: 'Verken merken en collecties per categorie, ontdek uitgelichte Brand Spotlights of laat je inspireren door de homepagina.',
        gradient: 'bg-gradient-to-br from-pink-100 to-purple-100'
      },
      {
        icon: Sparkles,
        step: 2,
        title: 'Ontdekken',
        description: 'Vind nieuwe Europese merken die je elders mist, gepresenteerd met redactionele context: wat maakt ze interessant, voor wie zijn ze, waar komen ze vandaan.',
        gradient: 'bg-gradient-to-br from-purple-100 to-indigo-100'
      },
      {
        icon: ArrowUpRight,
        step: 3,
        title: 'Doorklikken',
        description: 'Klaar om te kopen? Eén klik en je bent op de officiële merksite. Wij sturen geen orders, jij sluit je aankoop direct bij het merk af.',
        gradient: 'bg-gradient-to-br from-indigo-100 to-pink-100'
      }
    ];
  }

  return [
    {
      icon: Compass,
      step: 1,
      title: 'Browse',
      description: 'Explore brands and collections by category, discover featured Brand Spotlights, or let the homepage inspire you.',
      gradient: 'bg-gradient-to-br from-pink-100 to-purple-100'
    },
    {
      icon: Sparkles,
      step: 2,
      title: 'Discover',
      description: 'Find new European brands you miss elsewhere, presented with editorial context: what makes them interesting, who they are for, where they come from.',
      gradient: 'bg-gradient-to-br from-purple-100 to-indigo-100'
    },
    {
      icon: ArrowUpRight,
      step: 3,
      title: 'Click through',
      description: "Ready to buy? One click takes you to the official brand site. We don't process orders \u2014 you complete your purchase directly at the brand.",
      gradient: 'bg-gradient-to-br from-indigo-100 to-pink-100'
    }
  ];
};

export const getPromises = (language) => {
  if (language === 'nl') {
    return [
      {
        icon: Target,
        title: 'Selectie boven kwantiteit',
        description: 'We kiezen merken op stijl, identiteit en betrouwbaarheid. Liever 100 goede dan 10.000 willekeurige.'
      },
      {
        icon: BookOpen,
        title: 'Context, geen catalogus',
        description: 'Elke categorie heeft een eigen invalshoek, geselecteerde merken krijgen een Brand Spotlight.'
      },
      {
        icon: Globe,
        title: 'Europese focus',
        description: 'Onze hoofdaandacht ligt op merken uit en voor de Benelux en bredere EU.'
      },
      {
        icon: Handshake,
        title: 'Transparant verdienmodel',
        description: 'We werken met affiliate-partnerships en directe brand-samenwerkingen. Klikken via U&Fashion kost jou niets extra, en houdt ons platform onafhankelijk.'
      }
    ];
  }

  return [
    {
      icon: Target,
      title: 'Selection over quantity',
      description: 'We choose brands on style, identity and reliability. Rather 100 good ones than 10,000 random ones.'
    },
    {
      icon: BookOpen,
      title: 'Context, not a catalogue',
      description: 'Each category has its own angle; selected brands get a dedicated Brand Spotlight.'
    },
    {
      icon: Globe,
      title: 'European focus',
      description: 'Our main attention goes to brands from and for the Benelux and broader EU.'
    },
    {
      icon: Handshake,
      title: 'Transparent business model',
      description: 'We work with affiliate partnerships and direct brand collaborations. Clicking via U&Fashion costs you nothing extra and keeps our platform independent.'
    }
  ];
};
